import { render, staticRenderFns } from "./InscricaoEvento.vue?vue&type=template&id=52f82df6&scoped=true&"
import script from "./InscricaoEvento.vue?vue&type=script&lang=js&"
export * from "./InscricaoEvento.vue?vue&type=script&lang=js&"
import style0 from "./InscricaoEvento.vue?vue&type=style&index=0&id=52f82df6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f82df6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VDivider,VForm,VOverlay,VProgressCircular})
